import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import BlockTypes from '../../../types/BlockTypes';
import parseElementDataset from '../../utils/parseElementDataset';
export default _defineProperty({}, BlockTypes.TODO, function (el, next) {
  var _parseElementDataset = parseElementDataset(el.dataset),
      type = _parseElementDataset.type,
      data = _objectWithoutProperties(_parseElementDataset, ["type"]);

  return {
    object: 'block',
    type: type,
    data: data,
    nodes: next(el.childNodes)
  };
});